import React, {useEffect} from 'react'
import {Field, WithValue} from 'simple-react-form'
import Select from 'orionsoft-parts/lib/components/fields/Select'
import ArrayComponent from 'App/components/fields/ArrayComponent'
import NumberField from 'orionsoft-parts/lib/components/fields/numeral/Number'
import ConditionField from './ConditionField'
import Checkbox from 'orionsoft-parts/lib/components/fields/Checkbox'

export default function Rules(props) {
  useEffect(() => {
    if (!props.value) {
      props.onChange([])
    }
  })
  if (!props.value) return null

  return (
    <Field
      fieldName="rules"
      label="Reglas"
      value={props.value}
      type={ArrayComponent}
      onChange={props.onChange}>
      <Field fieldName="applyAll" label="Aplican todas" type={Checkbox} />
      <Field fieldName="conditions" label="Condiciones" type={ArrayComponent}>
        <WithValue>
          {({option}) => (
            <>
              <Field
                label="Tipo de opción"
                fieldName="option"
                type={Select}
                description="Corresponde a la variable a considerar para la validación de la condición"
                options={[
                  {label: 'Categoría repartidor', value: 'vehicleCategory'},
                  {label: 'Prioridad del pedido', value: 'orderPriority'},
                  {label: 'Turno', value: 'shiftProperties'}
                ]}
              />
              {option ? <ConditionField countryCode="CL" option={option} /> : null}
            </>
          )}
        </WithValue>
      </Field>
      <Field
        type={NumberField}
        fieldName="value"
        label="Distancia a bonificar"
        description="Corresponde a la distancia que se bonificará (en Metros) al momento de asignar los pedidos."
      />
    </Field>
  )
}
